/**
 * SENSHI BUNDLE CART OVERRIDE - With Bag Colour Selection
 * Handles: San (3 bags), Ni (2 bags), Ichi (1 bag + 1 belt)
 * Each bag has: Bag Colour + Inner Print + Strap Colour + optional Embroidery
 * Embroidery is FREE on bundles - text stored as line item property only.
 * Bag colour determines which bag product variant ID is used for inventory.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('senshi-bundle-config');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { console.error('[Senshi] Config parse error:', e); return; }
  if (!config || !config.isBundle) return;

  var form = document.querySelector('.js-product-form');
  if (!form) { console.warn('[Senshi] Product form not found'); return; }

  // ── English-only regex: A-Z, a-z, 0-9, space, hyphen, apostrophe, period ──
  var ENGLISH_ONLY = /^[A-Za-z0-9 \-'.]*$/;

  function stripNonEnglish(str) {
    return str.replace(/[^A-Za-z0-9 \-'.]/g, '');
  }

  function showEmbroideryError(inputEl, msg) {
    var wrap = inputEl.closest('.senshi-embroidery-fields');
    if (!wrap) return;
    var el = wrap.querySelector('.senshi-bundle-emb-error');
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function clearEmbroideryError(inputEl) {
    var wrap = inputEl.closest('.senshi-embroidery-fields');
    if (!wrap) return;
    var el = wrap.querySelector('.senshi-bundle-emb-error');
    if (el) el.style.display = 'none';
  }

  // --- Init swatch groups ---
  for (var bagIdx = 1; bagIdx <= config.bagCount; bagIdx++) {
    initBagColourGroup(bagIdx);
    initSwatchGroup('senshi-print-swatches-' + bagIdx, 'senshi-print-selected-' + bagIdx);
    initSwatchGroup('senshi-strap-swatches-' + bagIdx, 'senshi-strap-selected-' + bagIdx);
  }

  if (config.hasBelt) {
    initSwatchGroup('senshi-belt-colour-swatches', 'senshi-belt-colour-selected');
    initSizeGroup();
  }

  // --- Bag colour button group ---
  function initBagColourGroup(idx) {
    var container = document.getElementById('senshi-bag-colour-options-' + idx);
    if (!container) return;
    var btns = container.querySelectorAll('.senshi-bag-colour-btn');
    var details = document.getElementById('senshi-bag-details-' + idx);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('senshi-bag-colour-btn--active'); });
        btn.classList.add('senshi-bag-colour-btn--active');
        btn.querySelector('input[type="radio"]').checked = true;
        if (details) details.style.display = '';
      });
    });
  }

  // --- Generic swatch group ---
  function initSwatchGroup(containerId, displayId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var swatches = container.querySelectorAll('.senshi-swatch');
    var display = document.getElementById(displayId);

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        if (swatch.dataset.available === 'false') { e.preventDefault(); return; }
        swatches.forEach(function (s) { s.classList.remove('senshi-swatch--active'); });
        swatch.classList.add('senshi-swatch--active');
        swatch.querySelector('input[type="radio"]').checked = true;
        var value = swatch.dataset.colour || swatch.dataset.value;
        if (display) display.textContent = value;
        if (containerId === 'senshi-belt-colour-swatches') updateBeltSizeAvailability();
      });
    });
  }

  // --- Belt size group ---
  function initSizeGroup() {
    var sizeButtons = document.querySelectorAll('#senshi-belt-size-options .senshi-size-btn');
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.classList.contains('senshi-size-btn--soldout')) { e.preventDefault(); return; }
        sizeButtons.forEach(function (b) { b.classList.remove('senshi-size-btn--active'); });
        btn.classList.add('senshi-size-btn--active');
        btn.querySelector('input[type="radio"]').checked = true;
      });
    });
  }

  function updateBeltSizeAvailability() {
    if (!config.hasBelt || !config.beltVariants) return;
    var colourRadio = document.querySelector('input[name="senshi-belt-colour"]:checked');
    var selectedColour = colourRadio ? colourRadio.value : '';
    var sizeButtons = document.querySelectorAll('#senshi-belt-size-options .senshi-size-btn');
    var sizeRadio = document.querySelector('input[name="senshi-belt-size"]:checked');
    var currentSize = sizeRadio ? sizeRadio.value : null;
    var currentSizeAvailable = false;

    sizeButtons.forEach(function (btn) {
      var size = btn.dataset.size;
      var available = false;
      for (var i = 0; i < config.beltVariants.length; i++) {
        if (config.beltVariants[i].option1 === selectedColour && config.beltVariants[i].option2 === size && config.beltVariants[i].available) {
          available = true; break;
        }
      }
      btn.classList.toggle('senshi-size-btn--soldout', !available);
      var radio = btn.querySelector('input[type="radio"]');
      if (radio) radio.disabled = !available;
      if (size === currentSize && available) currentSizeAvailable = true;
    });

    if (!currentSizeAvailable) {
      sizeButtons.forEach(function (btn) { btn.classList.remove('senshi-size-btn--active'); });
      for (var i = 0; i < sizeButtons.length; i++) {
        if (!sizeButtons[i].classList.contains('senshi-size-btn--soldout')) {
          sizeButtons[i].classList.add('senshi-size-btn--active');
          sizeButtons[i].querySelector('input[type="radio"]').checked = true;
          break;
        }
      }
    }
  }

  // --- Embroidery toggles ---
  document.querySelectorAll('.senshi-bundle-emb-toggle').forEach(function (toggle) {
    var fields = document.getElementById(toggle.dataset.target);
    if (!fields) return;
    toggle.addEventListener('change', function () {
      fields.style.display = toggle.checked ? 'block' : 'none';
      var textInput = fields.querySelector('.senshi-bundle-emb-text');
      if (!toggle.checked && textInput) {
        textInput.value = '';
        var counter = document.querySelector('.senshi-char-current[data-for="' + textInput.id + '"]');
        if (counter) counter.textContent = '0';
        clearEmbroideryError(textInput);
      }
      if (toggle.checked && textInput) textInput.focus();
    });
  });

  // --- Char counters + real-time English-only stripping ---
  document.querySelectorAll('.senshi-bundle-emb-text').forEach(function (input) {
    input.addEventListener('input', function () {
      var cursor = input.selectionStart;
      var original = input.value;
      var cleaned = stripNonEnglish(original);

      if (cleaned !== original) {
        input.value = cleaned;
        var removed = original.length - cleaned.length;
        input.setSelectionRange(cursor - removed, cursor - removed);
        showEmbroideryError(input, 'English characters only (A-Z, 0-9, spaces and basic punctuation).');
      } else {
        clearEmbroideryError(input);
      }

      var counter = document.querySelector('.senshi-char-current[data-for="' + input.id + '"]');
      if (counter) counter.textContent = input.value.length;
    });

    // Catch paste events
    input.addEventListener('paste', function (e) {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text');
      var cleaned = stripNonEnglish(pasted).substring(0, 10);
      var start = input.selectionStart;
      var end = input.selectionEnd;
      var current = input.value;
      var newVal = (current.substring(0, start) + cleaned + current.substring(end)).substring(0, 10);
      input.value = newVal;
      var counter = document.querySelector('.senshi-char-current[data-for="' + input.id + '"]');
      if (counter) counter.textContent = newVal.length;
      if (pasted !== cleaned) {
        showEmbroideryError(input, 'Non-English characters were removed from your paste.');
      } else {
        clearEmbroideryError(input);
      }
    });
  });

  // --- Find bag variant by colour + print ---
  function findBagVariantId(bagColour, printName) {
    var bagData = config.bagProducts[bagColour];
    if (!bagData || !bagData.variants) return null;
    for (var i = 0; i < bagData.variants.length; i++) {
      if (bagData.variants[i].title === printName) return bagData.variants[i].id;
    }
    return null;
  }

  // --- Find belt variant ---
  function findBeltVariant(colour, size) {
    if (!config.beltVariants) return null;
    for (var i = 0; i < config.beltVariants.length; i++) {
      if (config.beltVariants[i].option1 === colour && config.beltVariants[i].option2 === size) return config.beltVariants[i];
    }
    return null;
  }

  // --- Intercept form ---
  form.addEventListener('submit', function (e) {
    if (!document.getElementById('senshi-bundle-fields')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    handleBundleAddToCart();
  }, true);

  var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      if (!document.getElementById('senshi-bundle-fields')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      handleBundleAddToCart();
    }, true);
  }

  // --- Main add-to-cart ---
  async function handleBundleAddToCart() {
    var properties = {};

    for (var i = 1; i <= config.bagCount; i++) {
      var prefix = config.bagCount > 1 ? 'Bag ' + i + ' ' : '';

      var bagColourRadio = document.querySelector('input[name="senshi-bag-colour-' + i + '"]:checked');
      if (!bagColourRadio) { showError('Please select a Bag Colour for ' + (prefix || 'your bag') + '.'); return; }
      var bagColour = bagColourRadio.value;
      properties[prefix + 'Bag Colour'] = bagColour;

      var printRadio = document.querySelector('input[name="senshi-print-' + i + '"]:checked');
      if (!printRadio) { showError('Please select an Inner Print for ' + (prefix || 'your bag') + '.'); return; }
      properties[prefix + 'Inner Print'] = printRadio.value;

      var bagVariantId = findBagVariantId(bagColour, printRadio.value);
      if (!bagVariantId) { showError('Could not find bag variant for ' + bagColour + ' / ' + printRadio.value + '. Please try again.'); return; }
      properties['_bag' + i + '_variant_id'] = String(bagVariantId);

      var strapRadio = document.querySelector('input[name="senshi-strap-' + i + '"]:checked');
      if (!strapRadio) { showError('Please select a Strap Colour for ' + (prefix || 'your bag') + '.'); return; }
      properties[prefix + 'Strap Colour'] = strapRadio.value;
      properties['_bag' + i + '_strap_variant_id'] = strapRadio.dataset.variantId;

      var embToggle = document.getElementById('senshi-emb-toggle-bag-' + i);
      var embText = document.getElementById('senshi-emb-text-bag-' + i);
      if (embToggle && embToggle.checked) {
        var text = embText ? embText.value.trim() : '';
        if (text.length === 0) { showError('Please enter embroidery text for ' + (prefix || '') + 'Strap.'); if (embText) embText.focus(); return; }
        if (text.length > 10) { showError('Embroidery text must be 10 characters or less.'); if (embText) embText.focus(); return; }
        if (!ENGLISH_ONLY.test(text)) { showError('Embroidery text must use English characters only.'); if (embText) embText.focus(); return; }
        properties[prefix + 'Strap Embroidery'] = text;
      }
    }

    // Belt (Ichi)
    if (config.hasBelt) {
      var beltColourRadio = document.querySelector('input[name="senshi-belt-colour"]:checked');
      var beltSizeRadio = document.querySelector('input[name="senshi-belt-size"]:checked');
      if (!beltColourRadio) { showError('Please select a Belt Colour.'); return; }
      if (!beltSizeRadio) { showError('Please select a Belt Size.'); return; }

      var beltVariant = findBeltVariant(beltColourRadio.value, beltSizeRadio.value);
      if (!beltVariant) { showError('This belt colour/size combination is not available.'); return; }
      if (!beltVariant.available) { showError('This belt combination is currently sold out.'); return; }

      properties['Belt Colour'] = beltColourRadio.value;
      properties['Belt Size'] = beltSizeRadio.value;
      properties['_belt_variant_id'] = String(beltVariant.id);

      var embToggleBelt = document.getElementById('senshi-emb-toggle-belt');
      var embTextBelt = document.getElementById('senshi-emb-text-belt');
      if (embToggleBelt && embToggleBelt.checked) {
        var beltText = embTextBelt ? embTextBelt.value.trim() : '';
        if (beltText.length === 0) { showError('Please enter embroidery text for the Belt.'); if (embTextBelt) embTextBelt.focus(); return; }
        if (beltText.length > 10) { showError('Embroidery text must be 10 characters or less.'); if (embTextBelt) embTextBelt.focus(); return; }
        if (!ENGLISH_ONLY.test(beltText)) { showError('Embroidery text must use English characters only.'); if (embTextBelt) embTextBelt.focus(); return; }
        properties['Belt Embroidery'] = beltText;
      }
    }

    var items = [{ id: config.bundleVariantId, quantity: 1, properties: properties }];

    setButtonLoading(true);
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) {
        var errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Could not add to cart');
      }
      var data = await response.json();
      await triggerCartUpdate(data);
    } catch (err) {
      console.error('[Senshi] Bundle add to cart error:', err);
      showError(err.message || 'Error adding to cart. Please try again.');
    } finally {
      setButtonLoading(false);
    }
  }

  async function triggerCartUpdate(addData) {
    try {
      var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      var cart = await cartResponse.json();
      updateCartCount(cart.item_count);
      var miniCart = document.querySelector('.mini-cart, .js-mini-cart, [data-mini-cart]');
      if (miniCart) {
        miniCart.classList.add('is-active', 'is-open');
        var overlay = document.querySelector('.page-overlay, .js-page-overlay');
        if (overlay) overlay.classList.add('is-active');
        return;
      }
      window.location.href = '/cart';
    } catch (err) {
      window.location.href = '/cart';
    }
  }

  function updateCartCount(count) {
    var selectors = ['.js-cart-count','.cart-count','[data-cart-count]','.header__cart-count','.site-header__cart-count','.cart-link__count','.cart-icon__count'];
    if (count === null) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){return r.json();}).then(function(cart){setCountElements(selectors,cart.item_count);});
    } else {
      setCountElements(selectors, count);
    }
  }

  function setCountElements(selectors, count) {
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = count;
        if (count > 0) { el.style.display = ''; el.removeAttribute('hidden'); }
      });
    });
  }

  function setButtonLoading(loading) {
    var btn = form.querySelector('[type="submit"], button[name="add"], .js-add-to-cart');
    if (!btn) return;
    if (loading) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('btn--loading', 'is-loading'); }
    else { btn.removeAttribute('disabled'); btn.classList.remove('btn--loading', 'is-loading'); }
  }

  function showError(msg) {
    var errorContainer = form.querySelector('.product-form__error, .js-form-error');
    if (errorContainer) {
      errorContainer.textContent = msg; errorContainer.style.display = 'block';
      setTimeout(function () { errorContainer.style.display = 'none'; }, 5000);
      return;
    }
    alert(msg);
  }
})();
